module.exports = __webpack_public_path__ + "account/assets/reporting.7423991d.svg";